export async function getResult(id) {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}results/${id}`);

    if (response.ok) return response.json();

    throw response;
}
